/* eslint-disable @next/next/no-img-element */
import { isEmpty } from 'lodash';
import {useState, useEffect} from 'react';

export default function Index({ title, options, oldSelected = [], set, isRequire = false }) {
    const [selecteds, setSelecteds] = useState(oldSelected);
    const [show, setShow] = useState(false);

    // useEffect(() => setOldSelected(oldSlt), [oldSlt]);

    const onAdd = (item) => {
        // setSelecteds(selecteds.concat(item.id));
        setSelecteds([item.id]);
    };

    const onRemove = (item) => {
        setSelecteds(selecteds.filter(x => x != item.id));
    };

    const apply = () => {
        set(selecteds);
        setShow(false);
    };

    useEffect(() => {
        set(selecteds);
        setShow(false);
    }, [selecteds]);

    return <div className="createPost-select">
        <div className="filterItem filterItem--select dropdown">
            <button className={'btn btn--dropdown btn--dropdown--white ' + (!isEmpty(selecteds) ? 'active' : '')}
                data-toggle="dropdown"
                onClick={() => {
                    setShow(true);
                }}>
                {
                    options.find(x => x.id == (selecteds[0]?.id || selecteds[0]))
                        ? options.find(x => x.id == (selecteds[0]?.id || selecteds[0]))?.text
                        : <>
                            {title}
                            {isRequire && <span style={{ color: 'red' }}> *</span>}
                        </>
                }
            </button>
            <div className={"dropdown-menu dropdown-menu--mw290 " + (show ? 'show' : '')}>
                <div className="filterBox filterBox-mb">
                    <div className="filterHeader">
                        <span className="filter-tlt">{title}</span>
                        <span className="filter-close"><img src="/images/icon-close.png" alt="" onClick={() => setShow(false)}/></span>
                    </div>
                    <ul className="filter-list filter-list--check">
                        {options.map((item, index) => {
                            const isSelected = selecteds.find(x => x === item.id) ? 'active' : '';
                            return <li key={index} className={isSelected ? 'active' : ''} onClick={() => isSelected ? onRemove(item) : onAdd(item)}>
                                {item.text}
                            </li>;
                        })}
                    </ul>
                    {/* <div className="filter-btn">
                        <button className="btn btn--blue" onClick={apply}>Áp dụng</button>
                    </div> */}
                </div>
            </div>
        </div>
        {show && <div className="backdrop"
            onClick={() => setShow(false)}>
        </div>}
    </div>;
};